var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "registration-form" },
    [
      _c(
        "v-card",
        { staticClass: "popups-register" },
        [
          _c("v-card-title", [
            _vm.step > 1 && _vm.step < 4
              ? _c(
                  "span",
                  { staticClass: "back", on: { click: _vm.decrementStep } },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "17",
                          height: "14",
                          viewBox: "0 0 17 14",
                          fill: "none",
                          xmlns: "http://www.w3.org/2000/svg"
                        }
                      },
                      [
                        _c("rect", {
                          attrs: {
                            x: "3",
                            y: "6",
                            width: "14",
                            height: "2",
                            fill: "white"
                          }
                        }),
                        _c("path", {
                          attrs: {
                            d: "M8 1L2 7L8 13",
                            stroke: "white",
                            "stroke-width": "2"
                          }
                        })
                      ]
                    )
                  ]
                )
              : _vm._e(),
            _vm.dialogTitle
              ? _c("span", {
                  staticClass: "headline",
                  domProps: { innerHTML: _vm._s(_vm.dialogTitle) }
                })
              : _vm._e()
          ]),
          _c("v-card-text", { staticClass: "loading-wrapper" }, [
            _vm.loading
              ? _c("span", {
                  staticClass: "preloader",
                  style: {
                    backgroundImage:
                      "url('" + _vm.preloaderBackgroundImage + "')"
                  }
                })
              : _vm._e(),
            _c("div", { staticClass: "register-step" }, [
              _vm.step < 4
                ? _c("div", { staticClass: "register-step__bar" }, [
                    _c(
                      "ul",
                      {
                        class: {
                          max3: _vm.phoneVerificationAllowed,
                          max2: !_vm.phoneVerificationAllowed
                        }
                      },
                      [
                        _c("li", { staticClass: "active" }, [
                          _c("div", { staticClass: "text" }, [
                            _c("div", { staticClass: "text-step" }, [
                              _vm._v("1")
                            ]),
                            _c("div", { staticClass: "text-name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "front.sign_in.register.titles.steps.account"
                                  )
                                )
                              )
                            ])
                          ])
                        ]),
                        _vm.phoneVerificationAllowed
                          ? _c("li", { class: { active: _vm.step >= 2 } }, [
                              _c("div", { staticClass: "text" }, [
                                _c("div", { staticClass: "text-step" }, [
                                  _vm._v("2")
                                ]),
                                _c("div", { staticClass: "text-name" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "front.sign_in.register.titles.steps.verification"
                                      )
                                    ) + "\n                                "
                                  )
                                ])
                              ])
                            ])
                          : _vm._e(),
                        _c("li", { class: { active: _vm.step >= 3 } }, [
                          _c("div", { staticClass: "text" }, [
                            _vm.phoneVerificationAllowed
                              ? _c("div", { staticClass: "text-step" }, [
                                  _vm._v("3")
                                ])
                              : _c("div", { staticClass: "text-step" }, [
                                  _vm._v("2")
                                ]),
                            _c("div", { staticClass: "text-name" }, [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "front.sign_in.register.titles.steps.details"
                                  )
                                )
                              )
                            ])
                          ])
                        ])
                      ]
                    )
                  ])
                : _vm._e(),
              _c("div", { staticClass: "register-step__content" }, [
                _vm.step < 3
                  ? _c("div", { staticClass: "register-step__start" }, [
                      _c("div", { staticClass: "steps-content" }, [
                        _vm.step === 1
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "steps-content__box register-step__one"
                              },
                              [
                                _c("h2", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "front.sign_in.register.descriptions.create_account"
                                      )
                                    )
                                  )
                                ]),
                                _c(
                                  "v-form",
                                  {
                                    ref: "formOne",
                                    attrs: { "lazy-validation": "" },
                                    model: {
                                      value: _vm.validStepOne,
                                      callback: function($$v) {
                                        _vm.validStepOne = $$v
                                      },
                                      expression: "validStepOne"
                                    }
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            rules: _vm.usernameRules,
                                            label: _vm.$t(
                                              "front.sign_in.register.form.username"
                                            ),
                                            required: "",
                                            autocomplete: "off"
                                          },
                                          model: {
                                            value: _vm.username,
                                            callback: function($$v) {
                                              _vm.username = $$v
                                            },
                                            expression: "username"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "text",
                                            rules: _vm.cpfCnpjRules,
                                            label: _vm.$t(
                                              "front.sign_in.register.form.cpf_cnpj"
                                            ),
                                            required: "",
                                            autocomplete: "off"
                                          },
                                          model: {
                                            value: _vm.cpfCnpj,
                                            callback: function($$v) {
                                              _vm.cpfCnpj = $$v
                                            },
                                            expression: "cpfCnpj"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "email",
                                            rules: _vm.emailRules,
                                            label: _vm.$t(
                                              "front.sign_in.register.form.email"
                                            ),
                                            required: "",
                                            autocomplete: "off"
                                          },
                                          model: {
                                            value: _vm.email,
                                            callback: function($$v) {
                                              _vm.email = $$v
                                            },
                                            expression: "email"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "password",
                                            rules: _vm.passwordRules,
                                            label: _vm.$t(
                                              "front.sign_in.register.form.password"
                                            ),
                                            required: "",
                                            autocomplete: "off"
                                          },
                                          model: {
                                            value: _vm.password,
                                            callback: function($$v) {
                                              _vm.password = $$v
                                            },
                                            expression: "password"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            rules: _vm.regulationsCheckRules
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "label",
                                                fn: function() {
                                                  return [
                                                    _c("div", [
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "front.sign_in.register.form.terms_conditions.accept"
                                                            )
                                                          ) +
                                                          "\n                                                    "
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              _vm.termsAndConditionsRoute,
                                                            target: "_blank"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "front.sign_in.register.form.terms_conditions.terms_and_conditions"
                                                                )
                                                              ) +
                                                              "\n                                                    "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        ",\n                                                    "
                                                      ),
                                                      _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href:
                                                              _vm.privacyAndCookiePolicyRoute,
                                                            target: "_blank"
                                                          },
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              $event.stopPropagation()
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                                                        " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "front.sign_in.register.form.terms_conditions.privacy_policy"
                                                                )
                                                              ) +
                                                              "\n                                                    "
                                                          )
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        "\n                                                    " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "front.sign_in.register.form.terms_conditions.years_old"
                                                            )
                                                          ) +
                                                          "\n                                                "
                                                      )
                                                    ])
                                                  ]
                                                },
                                                proxy: true
                                              }
                                            ],
                                            null,
                                            false,
                                            350661181
                                          ),
                                          model: {
                                            value: _vm.regulationsCheck,
                                            callback: function($$v) {
                                              _vm.regulationsCheck = $$v
                                            },
                                            expression: "regulationsCheck"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c(
                                      "div",
                                      { staticClass: "form-group" },
                                      [
                                        _c("v-checkbox", {
                                          attrs: {
                                            label: _vm.$t(
                                              "front.sign_in.register.form.subscribe_newsletter"
                                            )
                                          },
                                          model: {
                                            value: _vm.subscribeNewsCheck,
                                            callback: function($$v) {
                                              _vm.subscribeNewsCheck = $$v
                                            },
                                            expression: "subscribeNewsCheck"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _c("v-btn", {
                                      attrs: {
                                        disabled:
                                          !_vm.validStepOne || _vm.loading
                                      },
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t("front.modal.buttons.next")
                                        )
                                      },
                                      on: { click: _vm.submitFormOne }
                                    })
                                  ],
                                  1
                                ),
                                _c("div", { staticClass: "login" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "front.sign_in.register.descriptions.already_member"
                                      )
                                    ) + "\n                                    "
                                  ),
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "front.sign_in.register.button.login"
                                        )
                                      )
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.openLogin()
                                      }
                                    }
                                  })
                                ])
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.step === 2
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "steps-content__box register-step__two"
                              },
                              [
                                _c("h2", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "front.sign_in.register.descriptions.enter_mobile"
                                      )
                                    )
                                  )
                                ]),
                                !_vm.phoneVerificationCodeSent
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "register-step__two-telephone"
                                      },
                                      [
                                        _c(
                                          "v-form",
                                          {
                                            ref: "formTelephone",
                                            attrs: { "lazy-validation": "" },
                                            on: {
                                              submit: function($event) {
                                                $event.preventDefault()
                                              }
                                            },
                                            model: {
                                              value: _vm.validStepTelephone,
                                              callback: function($$v) {
                                                _vm.validStepTelephone = $$v
                                              },
                                              expression: "validStepTelephone"
                                            }
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "form-group registration-phone"
                                              },
                                              [
                                                _c("vue-tel-input", {
                                                  attrs: {
                                                    placeholder: _vm.$t(
                                                      "front.sign_in.register.form.phone_number_placeholder"
                                                    ),
                                                    enabledCountryCode: true,
                                                    preferredCountries:
                                                      _vm.preferredCountries,
                                                    mode: "international",
                                                    autoDefaultCountry: false,
                                                    defaultCountry:
                                                      _vm.countryCode
                                                  },
                                                  on: {
                                                    validate:
                                                      _vm.changePhoneValidationStatus,
                                                    input: _vm.phoneInput
                                                  },
                                                  model: {
                                                    value: _vm.phone,
                                                    callback: function($$v) {
                                                      _vm.phone = $$v
                                                    },
                                                    expression: "phone"
                                                  }
                                                }),
                                                _vm.phone !== undefined &&
                                                !_vm.isPhoneNumberValid
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "v-text-field__details"
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "v-messages theme--dark error--text",
                                                            attrs: {
                                                              role: "alert"
                                                            }
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "v-messages__wrapper"
                                                              },
                                                              [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "v-messages__message message-transition-enter-to"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                                            " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "front.validation.phone_number.valid"
                                                                          )
                                                                        ) +
                                                                        "\n                                                        "
                                                                    )
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm.captcha
                                              ? _c(
                                                  "div",
                                                  {
                                                    attrs: {
                                                      id:
                                                        "phone-verification-captcha"
                                                    }
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src:
                                                              _vm.captcha.img,
                                                            alt: "Captcha"
                                                          }
                                                        }),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            on: {
                                                              click:
                                                                _vm.refreshCaptcha
                                                            }
                                                          },
                                                          [
                                                            _c("v-icon", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.mdiRefresh
                                                                )
                                                              )
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "form-group"
                                                      },
                                                      [
                                                        _c("v-text-field", {
                                                          attrs: {
                                                            type: "text",
                                                            rules:
                                                              _vm.captchaValueRules,
                                                            label: _vm.$t(
                                                              "front.sign_in.register.form.captcha"
                                                            ),
                                                            required: "",
                                                            autocomplete: "off"
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.captchaValue,
                                                            callback: function(
                                                              $$v
                                                            ) {
                                                              _vm.captchaValue = $$v
                                                            },
                                                            expression:
                                                              "captchaValue"
                                                          }
                                                        })
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                )
                                              : _vm._e()
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              disabled:
                                                !_vm.validStepTelephone ||
                                                !this.isPhoneNumberValid
                                            },
                                            on: {
                                              click: _vm.submitFormTelephone
                                            }
                                          },
                                          [
                                            _c("span", {
                                              domProps: {
                                                textContent: _vm._s(
                                                  _vm.enterPhoneButtonText
                                                )
                                              }
                                            })
                                          ]
                                        ),
                                        _c("p", {
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.enterPhoneDescription
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      {
                                        staticClass: "register-step__two-code"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "info-text" },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "front.sign_in.register.descriptions.code_sent_to_mobile",
                                                  { phone: _vm.phone }
                                                )
                                              ) +
                                                "\n                                    "
                                            )
                                          ]
                                        ),
                                        _c("v-form", [
                                          _c(
                                            "div",
                                            { staticClass: "form-group" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.code_1,
                                                    expression: "code_1"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "-",
                                                  required: ""
                                                },
                                                domProps: { value: _vm.code_1 },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.code_1 =
                                                        $event.target.value
                                                    },
                                                    function($event) {
                                                      return _vm.verificationCodeInput(
                                                        $event,
                                                        1
                                                      )
                                                    }
                                                  ]
                                                }
                                              }),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.code_2,
                                                    expression: "code_2"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "-",
                                                  required: ""
                                                },
                                                domProps: { value: _vm.code_2 },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.code_2 =
                                                        $event.target.value
                                                    },
                                                    function($event) {
                                                      return _vm.verificationCodeInput(
                                                        $event,
                                                        2
                                                      )
                                                    }
                                                  ]
                                                }
                                              }),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.code_3,
                                                    expression: "code_3"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "-",
                                                  required: ""
                                                },
                                                domProps: { value: _vm.code_3 },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.code_3 =
                                                        $event.target.value
                                                    },
                                                    function($event) {
                                                      return _vm.verificationCodeInput(
                                                        $event,
                                                        3
                                                      )
                                                    }
                                                  ]
                                                }
                                              }),
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.code_4,
                                                    expression: "code_4"
                                                  }
                                                ],
                                                attrs: {
                                                  type: "text",
                                                  placeholder: "-",
                                                  required: ""
                                                },
                                                domProps: { value: _vm.code_4 },
                                                on: {
                                                  input: [
                                                    function($event) {
                                                      if (
                                                        $event.target.composing
                                                      ) {
                                                        return
                                                      }
                                                      _vm.code_4 =
                                                        $event.target.value
                                                    },
                                                    function($event) {
                                                      return _vm.verificationCodeInput(
                                                        $event,
                                                        4
                                                      )
                                                    }
                                                  ]
                                                }
                                              })
                                            ]
                                          )
                                        ]),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn-back",
                                            on: { click: _vm.editPhoneNumber }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "front.sign_in.register.button.edit_phone"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              disabled: !_vm.phoneCodeValid
                                            },
                                            on: { click: _vm.submitFormCode }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                        " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "front.sign_in.register.button.confirm"
                                                  )
                                                ) +
                                                "\n                                    "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                              ]
                            )
                          : _vm._e()
                      ]),
                      _c(
                        "div",
                        { staticClass: "steps-info" },
                        [
                          _c("single-page-part", {
                            attrs: { pagePart: _vm.registrationPromo }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e(),
                _vm.step === 3
                  ? _c(
                      "div",
                      {
                        staticClass: "register-step__finish register-step__tree"
                      },
                      [
                        _c("h2", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "front.sign_in.register.descriptions.almost_there"
                              )
                            )
                          )
                        ]),
                        _c(
                          "v-form",
                          {
                            ref: "formDetails",
                            attrs: { "lazy-validation": "" },
                            model: {
                              value: _vm.validStepDetails,
                              callback: function($$v) {
                                _vm.validStepDetails = $$v
                              },
                              expression: "validStepDetails"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("v-text-field", {
                                  attrs: {
                                    type: "text",
                                    rules: _vm.firstNameRules,
                                    label: _vm.$t(
                                      "front.sign_in.register.form.first_name"
                                    ),
                                    required: "",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: _vm.firstName,
                                    callback: function($$v) {
                                      _vm.firstName = $$v
                                    },
                                    expression: "firstName"
                                  }
                                }),
                                _c("v-text-field", {
                                  attrs: {
                                    type: "text",
                                    rules: _vm.lastNameRules,
                                    label: _vm.$t(
                                      "front.sign_in.register.form.last_name"
                                    ),
                                    required: "",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: _vm.lastName,
                                    callback: function($$v) {
                                      _vm.lastName = $$v
                                    },
                                    expression: "lastName"
                                  }
                                }),
                                _c("label", { staticClass: "genderLabel" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "front.sign_in.register.form.gender"
                                      )
                                    )
                                  )
                                ]),
                                _c(
                                  "v-radio-group",
                                  {
                                    model: {
                                      value: _vm.gender,
                                      callback: function($$v) {
                                        _vm.gender = $$v
                                      },
                                      expression: "gender"
                                    }
                                  },
                                  [
                                    _c("v-radio", {
                                      attrs: {
                                        label: _vm.$t(
                                          "front.sign_in.register.form.male"
                                        ),
                                        value: "Male"
                                      }
                                    }),
                                    _c("v-radio", {
                                      attrs: {
                                        label: _vm.$t(
                                          "front.sign_in.register.form.female"
                                        ),
                                        value: "Female"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    label: _vm.$t(
                                      "front.sign_in.register.form.birthday"
                                    ),
                                    placeholder: _vm.birthdayFormat,
                                    "append-icon": _vm.mdiCalendar,
                                    rules: _vm.birthdayRules
                                  },
                                  on: {
                                    "click:append": function($event) {
                                      _vm.modalDate = true
                                    }
                                  },
                                  model: {
                                    value: _vm.formattedBirthday,
                                    callback: function($$v) {
                                      _vm.formattedBirthday = $$v
                                    },
                                    expression: "formattedBirthday"
                                  }
                                }),
                                _c(
                                  "v-dialog",
                                  {
                                    ref: "modalDate",
                                    attrs: { persistent: "", width: "290px" },
                                    model: {
                                      value: _vm.modalDate,
                                      callback: function($$v) {
                                        _vm.modalDate = $$v
                                      },
                                      expression: "modalDate"
                                    }
                                  },
                                  [
                                    _c(
                                      "v-date-picker",
                                      {
                                        staticClass: "customPicker",
                                        attrs: {
                                          scrollable: "",
                                          "active-picker": "YEAR",
                                          "no-title": "",
                                          "picker-date": _vm.currentPickerDate,
                                          reactive: true,
                                          max: _vm.maxAllowedBirthDate
                                        },
                                        model: {
                                          value: _vm.calendarBirthday,
                                          callback: function($$v) {
                                            _vm.calendarBirthday = $$v
                                          },
                                          expression: "calendarBirthday"
                                        }
                                      },
                                      [
                                        _c("v-spacer"),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn-picker",
                                            attrs: { text: "" },
                                            on: {
                                              click: function($event) {
                                                _vm.modalDate = false
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "front.modal.buttons.cancel"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        ),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn-picker btn-back",
                                            attrs: {
                                              text: "",
                                              disabled: !_vm.calendarBirthday
                                            },
                                            on: {
                                              click: _vm.saveCalendarBirthday
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "front.modal.buttons.ok"
                                                  )
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass: "d-flex justify-space-between"
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "form-group currency-select",
                                        class: {
                                          "form-group-nested-left": !_vm.useAgentCode
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "select",
                                            attrs: { id: "currency-select" }
                                          },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                attach: "#currency-select",
                                                label: _vm.$t(
                                                  "front.sign_in.register.form.currency"
                                                ),
                                                items:
                                                  _vm.supportedCurrenciesCodes,
                                                "menu-props": {
                                                  contentClass: "menu-custom"
                                                }
                                              },
                                              model: {
                                                value: _vm.currency,
                                                callback: function($$v) {
                                                  _vm.currency = $$v
                                                },
                                                expression: "currency"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.useAgentCode,
                                            expression: "useAgentCode"
                                          }
                                        ],
                                        staticClass:
                                          "form-group form-group-nested-right agent-code"
                                      },
                                      [
                                        _c(
                                          "v-tooltip",
                                          {
                                            attrs: { top: "" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "activator",
                                                  fn: function(ref) {
                                                    var on = ref.on
                                                    var attrs = ref.attrs
                                                    return [
                                                      _c(
                                                        "v-btn",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                absolute: "",
                                                                icon: "",
                                                                "open-on-click":
                                                                  "",
                                                                "retain-focus-on-click":
                                                                  ""
                                                              }
                                                            },
                                                            "v-btn",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        ),
                                                        [
                                                          _c(
                                                            "svg",
                                                            {
                                                              staticStyle: {
                                                                "enable-background":
                                                                  "new 0 0 23.625 23.625"
                                                              },
                                                              attrs: {
                                                                xmlns:
                                                                  "http://www.w3.org/2000/svg",
                                                                "xmlns:xlink":
                                                                  "http://www.w3.org/1999/xlink",
                                                                version: "1.1",
                                                                id: "Capa_1",
                                                                x: "0px",
                                                                y: "0px",
                                                                viewBox:
                                                                  "0 0 23.625 23.625",
                                                                "xml:space":
                                                                  "preserve"
                                                              }
                                                            },
                                                            [
                                                              _c("g", [
                                                                _c("path", {
                                                                  staticStyle: {
                                                                    fill: "#333"
                                                                  },
                                                                  attrs: {
                                                                    d:
                                                                      "M11.812,0C5.289,0,0,5.289,0,11.812s5.289,11.813,11.812,11.813s11.813-5.29,11.813-11.813   S18.335,0,11.812,0z M14.271,18.307c-0.608,0.24-1.092,0.422-1.455,0.548c-0.362,0.126-0.783,0.189-1.262,0.189   c-0.736,0-1.309-0.18-1.717-0.539s-0.611-0.814-0.611-1.367c0-0.215,0.015-0.435,0.045-0.659c0.031-0.224,0.08-0.476,0.147-0.759   l0.761-2.688c0.067-0.258,0.125-0.503,0.171-0.731c0.046-0.23,0.068-0.441,0.068-0.633c0-0.342-0.071-0.582-0.212-0.717   c-0.143-0.135-0.412-0.201-0.813-0.201c-0.196,0-0.398,0.029-0.605,0.09c-0.205,0.063-0.383,0.12-0.529,0.176l0.201-0.828   c0.498-0.203,0.975-0.377,1.43-0.521c0.455-0.146,0.885-0.218,1.29-0.218c0.731,0,1.295,0.178,1.692,0.53   c0.395,0.353,0.594,0.812,0.594,1.376c0,0.117-0.014,0.323-0.041,0.617c-0.027,0.295-0.078,0.564-0.152,0.811l-0.757,2.68   c-0.062,0.215-0.117,0.461-0.167,0.736c-0.049,0.275-0.073,0.485-0.073,0.626c0,0.356,0.079,0.599,0.239,0.728   c0.158,0.129,0.435,0.194,0.827,0.194c0.185,0,0.392-0.033,0.626-0.097c0.232-0.064,0.4-0.121,0.506-0.17L14.271,18.307z    M14.137,7.429c-0.353,0.328-0.778,0.492-1.275,0.492c-0.496,0-0.924-0.164-1.28-0.492c-0.354-0.328-0.533-0.727-0.533-1.193   c0-0.465,0.18-0.865,0.533-1.196c0.356-0.332,0.784-0.497,1.28-0.497c0.497,0,0.923,0.165,1.275,0.497   c0.353,0.331,0.53,0.731,0.53,1.196C14.667,6.703,14.49,7.101,14.137,7.429z"
                                                                  }
                                                                })
                                                              ])
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              1151148631
                                            )
                                          },
                                          [
                                            _c("span", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "front.sign_in.register.form.tooltip_bonus_code"
                                                  )
                                                )
                                              )
                                            ])
                                          ]
                                        ),
                                        _c("v-text-field", {
                                          attrs: {
                                            type: "text",
                                            label: _vm.$t(
                                              "front.sign_in.register.form.bonus_code"
                                            ),
                                            title:
                                              "Hello This Will Have Some Value",
                                            disabled: !_vm.overrideAgentCodeAllowed,
                                            autocomplete: "off"
                                          },
                                          model: {
                                            value: _vm.agentCode,
                                            callback: function($$v) {
                                              _vm.agentCode = $$v
                                            },
                                            expression: "agentCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c(
                                  "div",
                                  { attrs: { id: "country-code-select" } },
                                  [
                                    _c("div", {
                                      staticClass: "country-code-select-label",
                                      domProps: {
                                        textContent: _vm._s(
                                          _vm.$t(
                                            "front.sign_in.register.form.country"
                                          )
                                        )
                                      }
                                    }),
                                    _c(
                                      "div",
                                      {
                                        attrs: {
                                          id: "country-code-select-autocomplete"
                                        }
                                      },
                                      [
                                        _c("v-autocomplete", {
                                          attrs: {
                                            rules: _vm.countryRules,
                                            items: _vm.showingCountries,
                                            "item-text": "title",
                                            "item-value": "code",
                                            "return-object": false,
                                            attach:
                                              "#country-code-select-autocomplete"
                                          },
                                          model: {
                                            value: _vm.countryCode,
                                            callback: function($$v) {
                                              _vm.countryCode = $$v
                                            },
                                            expression: "countryCode"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                ),
                                _c("v-text-field", {
                                  attrs: {
                                    type: "text",
                                    rules: _vm.addressRules,
                                    label: "Address",
                                    required: "",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: _vm.address,
                                    callback: function($$v) {
                                      _vm.address = $$v
                                    },
                                    expression: "address"
                                  }
                                }),
                                _c("v-text-field", {
                                  attrs: {
                                    type: "text",
                                    rules: _vm.cityRules,
                                    label: _vm.$t(
                                      "front.sign_in.register.form.city"
                                    ),
                                    required: "",
                                    autocomplete: "off"
                                  },
                                  model: {
                                    value: _vm.city,
                                    callback: function($$v) {
                                      _vm.city = $$v
                                    },
                                    expression: "city"
                                  }
                                }),
                                _vm.showingProvinces.length
                                  ? _c(
                                      "div",
                                      { attrs: { id: "province-code-select" } },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "province-code-select-label",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.$t(
                                                "front.sign_in.register.form.province"
                                              )
                                            )
                                          }
                                        }),
                                        _c(
                                          "div",
                                          {
                                            attrs: {
                                              id:
                                                "province-code-select-autocomplete"
                                            }
                                          },
                                          [
                                            _c("v-autocomplete", {
                                              attrs: {
                                                rules: _vm.provinceRules,
                                                items: _vm.showingProvinces,
                                                "item-text": "title",
                                                "item-value": "code",
                                                "return-object": false,
                                                attach:
                                                  "#province-code-select-autocomplete"
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "no-data",
                                                    fn: function() {
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "px-4 text-center"
                                                          },
                                                          [
                                                            _vm._v(
                                                              "\n                                                    " +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "front.sign_in.register.form.provinces_not_required"
                                                                  )
                                                                ) +
                                                                "\n                                                "
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    },
                                                    proxy: true
                                                  }
                                                ],
                                                null,
                                                false,
                                                766344221
                                              ),
                                              model: {
                                                value: _vm.provinceCode,
                                                callback: function($$v) {
                                                  _vm.provinceCode = $$v
                                                },
                                                expression: "provinceCode"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm.allowPostalCode
                                  ? _c("v-text-field", {
                                      attrs: {
                                        type: "text",
                                        rules: _vm.postalCodeRules,
                                        label: _vm.$t(
                                          "front.sign_in.register.form.postal_code"
                                        ),
                                        required: "",
                                        autocomplete: "off"
                                      },
                                      model: {
                                        value: _vm.postalCode,
                                        callback: function($$v) {
                                          _vm.postalCode = $$v
                                        },
                                        expression: "postalCode"
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            ),
                            !_vm.phoneVerificationAllowed
                              ? _c(
                                  "div",
                                  { staticClass: "form-group form-groupW100" },
                                  [
                                    _c("label", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t(
                                            "front.sign_in.register.form.phone_number"
                                          )
                                        )
                                      )
                                    ]),
                                    _c("vue-tel-input", {
                                      staticClass: "ltr ltr-element",
                                      attrs: {
                                        placeholder: _vm.$t(
                                          "front.sign_in.register.form.phone_number_placeholder"
                                        ),
                                        enabledCountryCode: true,
                                        preferredCountries:
                                          _vm.preferredCountries,
                                        mode: "international",
                                        autoDefaultCountry: false,
                                        defaultCountry: _vm.countryCode
                                      },
                                      on: {
                                        validate:
                                          _vm.changePhoneValidationStatus,
                                        input: _vm.phoneInput
                                      },
                                      model: {
                                        value: _vm.phone,
                                        callback: function($$v) {
                                          _vm.phone = $$v
                                        },
                                        expression: "phone"
                                      }
                                    }),
                                    _vm.phone !== undefined &&
                                    !_vm.isPhoneNumberValid
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "v-text-field__details"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "v-messages theme--dark error--text",
                                                attrs: { role: "alert" }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "v-messages__wrapper"
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "v-messages__message message-transition-enter-to"
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                                " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "front.validation.phone_number.valid"
                                                              )
                                                            ) +
                                                            "\n                                            "
                                                        )
                                                      ]
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.allowSecurityQuestions
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-group form-groupW100 select",
                                    attrs: { id: "security-question-select" }
                                  },
                                  [
                                    _c("v-select", {
                                      attrs: {
                                        attach: "#security-question-select",
                                        label: _vm.$t(
                                          "front.sign_in.register.form.security_question"
                                        ),
                                        items: _vm.securityQuestions,
                                        "menu-props": {
                                          contentClass: "menu-custom"
                                        }
                                      },
                                      model: {
                                        value: _vm.securityQuestion,
                                        callback: function($$v) {
                                          _vm.securityQuestion = $$v
                                        },
                                        expression: "securityQuestion"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.allowSecurityQuestions
                              ? _c(
                                  "div",
                                  { staticClass: "form-group form-groupW100" },
                                  [
                                    _c("v-text-field", {
                                      attrs: {
                                        type: "text",
                                        rules: _vm.answerRules,
                                        label: _vm.$t(
                                          "front.sign_in.register.form.security_answer"
                                        ),
                                        required: "",
                                        autocomplete: "off"
                                      },
                                      model: {
                                        value: _vm.answer,
                                        callback: function($$v) {
                                          _vm.answer = $$v
                                        },
                                        expression: "answer"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        ),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              disabled:
                                !_vm.validStepDetails ||
                                !this.isPhoneNumberValid ||
                                _vm.loading
                            },
                            on: { click: _vm.submitFormDetails }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(
                                  _vm.$t(
                                    "front.sign_in.register.button.register"
                                  )
                                ) +
                                "\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.step === 4
                  ? _c("div", { staticClass: "register-step__success" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "front.sign_in.register.descriptions.registration_successful"
                            )
                          )
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "front.sign_in.register.descriptions.successful_signed"
                            )
                          ) + " "
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.$t(
                                "front.sign_in.register.descriptions.activate_account"
                              )
                            ) +
                            "\n                        "
                        )
                      ]),
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "125",
                            height: "125",
                            viewBox: "0 0 125 125",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }
                        },
                        [
                          _c("g", [
                            _c("path", {
                              attrs: {
                                d:
                                  "M119.2 11C119.5 11.6 119.7 12 119.9 12.5C120.4 13.7 120.9 15 121.5 16.2C121.8 16.9 121.7 17.3 121.2 17.8C117.9 21 114.6 24.1 111.5 27.5C107 32.5 102.5 37.6 98.2 42.8C91.2999 51 85.1 59.7 79.3 68.7C73 78.4 67.1 88.3 62.4 98.9C61.9 100.1 61.4 101.3 60.9 102.6C60.9 102.6 60.7999 102.7 60.7 102.8C46 87.7 31.4 72.6 16.7 57.4C17.1 57 17.3999 56.7 17.7999 56.4C20.8999 53.9 24 51.4 27.1 48.8C27.7 48.3 28 48.3 28.6 48.8C36.6 55.2 44.5999 61.5 52.5999 67.9C52.8999 68.1 53.1 68.3 53.4 68.5C72.5 46.1 94.2 26.7 119.2 11Z",
                                fill: "#C4C4C4"
                              }
                            }),
                            _c("path", {
                              attrs: {
                                d:
                                  "M83.5999 10.0004C63.9999 3.00039 45.5999 4.90039 28.6999 17.2004C16.2999 26.3004 8.79989 38.8004 6.59989 54.1004C1.89989 86.8004 25.0999 114.3 54.3999 118.2C73.7999 120.8 90.5999 114.9 103.9 100.5C117.2 86.1004 121.2 68.9004 117.5 49.7004C117.7 49.7004 117.9 49.6004 118.1 49.6004C119.7 49.6004 121.2 49.6004 122.8 49.6004C123.3 49.6004 123.6 49.8004 123.6 50.3004C124 53.6004 124.5 56.9004 124.7 60.2004C125.1 66.0004 124.4 71.8004 123 77.4004C120.6 87.3004 116 96.0004 109.2 103.7C103.7 109.9 97.2999 114.9 89.7999 118.5C83.5999 121.5 77.1999 123.5 70.2999 124.3C65.5999 124.9 60.9999 125 56.2999 124.5C43.4999 123.2 32.0999 118.5 22.1999 110.2C15.3999 104.5 10.0999 97.7004 6.19989 89.8004C3.19989 83.7004 1.19989 77.2004 0.39989 70.4004C0.0998899 67.0004 -0.10011 63.6004 -0.000110088 60.1004C0.29989 53.1004 1.59989 46.3004 4.19989 39.8004C9.99989 25.2004 19.8999 14.3004 33.6999 7.00039C40.5999 3.40039 47.8999 1.20039 55.5999 0.400391C64.8999 -0.599609 73.9999 0.400391 82.7999 3.40039C83.4999 3.60039 83.7999 3.90039 83.6999 4.70039C83.5999 6.20039 83.6999 7.70039 83.6999 9.20039C83.6999 9.40039 83.5999 9.70039 83.5999 10.0004Z",
                                fill: "#C4C4C4"
                              }
                            })
                          ]),
                          _c("defs", [
                            _c("clipPath", { attrs: { id: "clip0" } }, [
                              _c("rect", {
                                attrs: {
                                  width: "124.8",
                                  height: "124.8",
                                  fill: "white"
                                }
                              })
                            ])
                          ])
                        ]
                      )
                    ])
                  : _vm._e(),
                _vm.step === 5
                  ? _c("div", { staticClass: "register-step__success" }, [
                      _c("h2", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "front.sign_in.register.descriptions.registration_unavailable"
                            )
                          )
                        )
                      ]),
                      _c("div", {
                        domProps: {
                          innerHTML: _vm._s(_vm.registrationUnavailableReason)
                        }
                      })
                    ])
                  : _vm._e()
              ])
            ])
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }